import { render } from "./ManagerTasksOverview.vue?vue&type=template&id=1394531a"
import script from "./ManagerTasksOverview.vue?vue&type=script&lang=js"
export * from "./ManagerTasksOverview.vue?vue&type=script&lang=js"

import "./ManagerTasksOverview.vue?vue&type=style&index=0&id=1394531a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__